// removed by extract-text-webpack-plugin
module.exports = {"pageSummary":"_3v5ds762VX"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountList.module.less
// module id = 978
// module chunks = 3